import 'swiper/swiper-bundle.css';
import Swiper, { Navigation, Pagination } from 'swiper';

export default class ProfileImageCarousel {
  constructor (carouselSelector) {
    Swiper.use([Navigation, Pagination]);

    this.addEvent(carouselSelector);
  }

  addEvent (carouselSelector) {
    const imagesElem = document.querySelector(carouselSelector).getElementsByClassName('swiper-slide');

    let option = {};
    if (imagesElem.length > 1) {
      option = {
        loop: true,
        navigation: {
          nextEl: '.js-swiper-button-next',
          prevEl: '.js-swiper-button-prev'
        }
      };
    } else {
      document.querySelector(carouselSelector).querySelector('.js-swiper-button-next').style.display = 'none';
      document.querySelector(carouselSelector).querySelector('.js-swiper-button-prev').style.display = 'none';
    }

    /* eslint-disable no-new */
    new Swiper(carouselSelector, option);
  }
}
